export const injectScript = (scriptContent: string): void => {
  try {
    const script = document.createElement('script');
    script.innerHTML = scriptContent;
    script.async = true;
    document.head.appendChild(script);
  } catch (error) {
    console.error('❌ Erro ao injetar script:', error);
  }
}; 